import { POST_STAFF_START } from '../../types';

export const post_staff = (payload) => ({
  type: POST_STAFF_START,
  payload,
});
